angular.module('core').filter('personPossessive', [
    function() {
        return function(name) {
            // Return possessive form of singular proper noun
            // using AP style.

            if (!name) {
                return name;
            }

            var endsInS = name.slice(-1).toLowerCase() === 's';

            return name + '\'' + (endsInS ? '' : 's');
        };
    }
]);
